module.exports = __webpack_public_path__ + "static/img/lock_icon.f0c8a0e5.png";